export const birthdayMilestoneLabel = (years) => {
  const value = Number(years);
  if (!Number.isInteger(value) || value < 1) return '';
  const suffix = value % 100 >= 11 && value % 100 <= 13
    ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[value % 10] || 'th');
  return `${value}${suffix} Birthday`;
};

export function secretBirthdayMessage(event = {}, webInviteLink = '') {
  const celebrant = (event.honoree_names || []).join(' & ') || '{{celebrant}}';
  const milestone = birthdayMilestoneLabel(event.milestone_number) || '{{years}}th Birthday';
  const items = [...(event.itinerary || [])].sort((a, b) =>
    `${a.date || ''} ${a.start_time || ''}`.localeCompare(`${b.date || ''} ${b.start_time || ''}`));
  const party = items.find((item) => /birthday|celebration|party/i.test(item.name || '')) || items[0] || {};
  const venue = party.venue || (event.venues || [])[0] || {};
  const address = party.venue_address || venue.address || party.venue_name || venue.name || '{{venue address}}';
  const rawDate = party.date || event.start_date;
  const parsedDate = rawDate ? new Date(String(rawDate).slice(0, 10) + 'T12:00:00') : null;
  const date = parsedDate && !Number.isNaN(parsedDate.getTime())
    ? parsedDate.toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' }) : '{{date}}';
  const time = party.start_time || event.start_time || '{{time}}';
  const dressCode = party.dress_code || event.dress_code || '{{dress code}}';
  const life = event.milestone_number === 60 ? 'six wonderful decades' : event.milestone_number
    ? `${event.milestone_number} wonderful years` : 'the wonderful years';
  return `We’re getting together to celebrate ${celebrant}’s ${milestone} — and we need your help to make it truly special! ❤️

Please join us for an evening of celebration, laughter, memories & a little bit of glamour as we celebrate ${life} of ${celebrant}’s life. 🥂✨

📅 ${date}
🕖 ${time} onwards
📍 ${address}
👗 Dress Code: ${dressCode}

MOST IMPORTANT: 🤫
Please keep this a secret from ${celebrant}!
No hints, no accidental mentions, no “see you at your birthday” messages! 😄
Let’s make sure the surprise stays a surprise! 🎉

Please view the invitation and confirm your RSVP using the link below so we can make the arrangements accordingly:
${webInviteLink || '{{web invite link}}'}`;
}
